import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
// import Lakshadeepam from "./Lakshadeepam";
import GalleryView from "./GalleryView";


// const BASE_URL = "https://talimahakshethram.org/images/";

// const galleryItems = Array.from({ length: 5 }, (_, i) => ({
//   type: "image",
//   url: `${BASE_URL}pic-0${i + 1}.jpeg`,
//   category: "latest",
// }));


const BASE_URL = "https://talimahakshethram.org/images/";

const generateItems = (prefix, count, type, category, ext = "jpeg") => {
  return Array.from({ length: count }, (_, i) => ({
    type,
    url: `${BASE_URL}${prefix}-${String(i + 1).padStart(2, "0")}.${ext}`,
    category,
  }));
};

// categories with NEW prefixes
const latestImages = generateItems("lat", 11, "image", "latest");
const eventImages = generateItems("eve", 5, "image", "events");
const festivalImages = generateItems("fes", 2, "image", "festival");
const videos = generateItems("vid", 3, "video", "video", "mp4");

// final array
const galleryItems = [
  ...latestImages,
  ...eventImages,
  ...festivalImages,
  ...videos,
];


// const galleryItems = [
//  { type: "image", url: "https://talimahakshethram.org/images/pic-01.jpeg", category: "latest" },
//   { type: "image", url: "https://talimahakshethram.org/images/pic-02.jpeg", category: "latest" },
//   { type: "image", url: "https://talimahakshethram.org/images/pic-03.jpeg", category: "latest" },
//   { type: "image", url: "https://talimahakshethram.org/images/pic-04.jpeg", category: "latest" },
//   { type: "image", url: "https://talimahakshethram.org/images/pic-05.jpeg", category: "latest" },

//   { type: "image", url: "https://talimahakshethram.org/images/pic-7.jpeg", category: "latest" },
//   { type: "image", url: "https://talimahakshethram.org/images/pic-8.jpeg", category: "latest" },
//   { type: "image", url: "https://talimahakshethram.org/images/pic-9.jpeg", category: "latest" },
//   { type: "image", url: "https://talimahakshethram.org/images/pic-10.jpeg", category: "latest" },
//   { type: "image", url: "https://talimahakshethram.org/images/pic-11.jpeg", category: "latest" },


//   { type: "video", url: "https://talimahakshethram.org/images/vid-1.mp4", category: "latest" },
//   { type: "video", url: "https://talimahakshethram.org/images/vid-2.mp4", category: "latest" },
//   { type: "video", url: "https://talimahakshethram.org/images/vid-3.mp4", category: "latest" },
// ];

function PhotoGallery() {
  const [filter, setFilter] = useState("all");

  const filteredItems =
    filter === "all"
      ? galleryItems
      : filter === "video"
        ? galleryItems.filter((item) => item.type === "video")
        : galleryItems.filter((item) => item.category === filter);

  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/simage-1.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>

      <div className="container" style={{ marginTop: "100px", marginBottom: "100px" }}>
        {/* <VideoGallery /> */}
        {/* <GalleryView /> */}

      </div>

      <div className="container" style={{ marginTop: "100px", marginBottom: "100px" }}>
        <div style={{ marginBottom: "20px" }}>
          <button className={`btn ${filter === "all" ? "btn-primary" : "btn-secondary"}`} onClick={() => setFilter("all")}>All</button>
          <button className={`btn ${filter === "latest" ? "btn-primary" : "btn-secondary"}`} onClick={() => setFilter("latest")}>Latest</button>
          <button className={`btn ${filter === "events" ? "btn-primary" : "btn-secondary"}`} onClick={() => setFilter("events")}>Events</button>
          <button className={`btn ${filter === "festival" ? "btn-primary" : "btn-secondary"}`} onClick={() => setFilter("festival")}>Festival</button>
          <button className={`btn ${filter === "video" ? "btn-primary" : "btn-secondary"}`} onClick={() => setFilter("video")}>Videos</button>
        </div>
        <div style={galleryStyle}>
          {filteredItems.map((item, index) => (
            <div key={index} style={itemStyle}>
              {item.type === "image" ? (
                <img src={item.url} alt={item.category} style={imgStyle} />
              ) : (
                <video src={item.url} controls style={videoStyle}></video>
              )}
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}

const galleryStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  gap: "15px",
};

const itemStyle = {
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
};

const imgStyle = {
  width: "100%",
  height: "auto",
  cursor: "pointer",
};

const videoStyle = {
  width: "100%",
  height: "auto",
};

export default PhotoGallery;
